import { i18n } from '@/commons/utils';
import { hideLoaderOrderBtn } from './payment';

export function formatUrl(url, orderId) {
  return `rest/model/com/decathlon/cube/commerce/payment/PaymentActor/${url}?orderId=${orderId || getOrderId()}`;
}

export function getOrderId() {
  let orderId;
  if ($('#modal-alipay').is(':visible')) {
    const generateOrderIdElt = document.querySelector('.generateOrderId');
    if (generateOrderIdElt) {
      orderId = generateOrderIdElt.getAttribute('value');
    } else {
      orderId = $('#alipay-form').find('[name=extra_common_param]').val().split(':')[1];
    }
    return orderId;
  }
  if ($('#express-content #modal-wechat').is(':visible')) {
    orderId = $('#modal-wechat').data('orderid');
    return orderId;

  }
  return (window.location.search.split('orderId=')[1] || '').split('&')[0];
}

export function getOrderParams(paymentData) {
  const container = $('body');
  const paymentGroupId = paymentData && paymentData.paymentGroupId || (container.hasClass('checkout') ? container.find('div.modal[data-payment-group-id]:not([data-payment-group-id="template"])').attr('data-payment-group-id') : container.find('[data-payment-group-id]:not([data-payment-group-id="template"])').attr('data-payment-groups-id'));

  let orderId = container.find('[data-order-id]').data('order-id');
  if (!orderId) {
    orderId = container.find('[data-order-refund-id]').data('order-id');
  }
  const paymentTypeId = container.hasClass('checkout') ?
    $('#payment-informations section.dkt-block--selected:not(#secondary-payment-block)').data('payment-type-id')
    : $('input[name=paymentTypeId]').val();
  const redirectionUrl = container.find('[data-redirection-url]').data('redirection-url');
  const altPaymentGroupId = container.find('[data-alt-payment-group-id]').data('alt-payment-group-id');

  return {
    paymentGroupId,
    orderId,
    paymentTypeId,
    redirectionUrl,
    altPaymentGroupId
  };
}

export function handleAcceptConditions() {
  const acceptConditions = $('#acceptConditions');
  if (acceptConditions.length > 0 && !acceptConditions.is(':checked')) {
    const message = i18n('payment.accept.termsAndConditions');
    const elementClass = 'credit-card-cvc-input-container';

    $(`.${elementClass}`).addClass(`${elementClass}--error`);

    $('body').pushAlert({
      text: message,
      type: 'danger',
      icon: 'bell'
    });

    hideLoaderOrderBtn();
    return false;
  }
  return true;
}

export function handleBillingAddress() {
  const billingAddress = $('#billing-address-content');
  if (billingAddress.find('.dkt-block-message').length > 0) {
    const message = i18n('payment.message.billingAddress');
    billingAddress.addClass('dkt-billing-address--error');
    $('body').pushAlert({
      text: message,
      type: 'danger',
      icon: 'bell'
    });

    hideLoaderOrderBtn();
    return false;
  }
  billingAddress.removeClass('dkt-billing-address--error');
  return true;
}

// Update urls hidden tags for express, checkout and refunds
export function updateUrls() {
  const urlTags = cube.$$('.js-hidden-url');
  const uri = `${window.location.protocol}//${window.location.host}`;
  [...urlTags].forEach(tag => {
    if (!tag.value.startsWith(uri)) {
      tag.value = `${uri}${tag.value}`;
    }
  });
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-utils.js